export class GridCode {
    static code: number = 0;
}